var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCareerLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.452 13.4027V14.4527H10.252V13.4027C7.85195 13.2827 5.72195 12.5327 4.25195 11.4227V16.7027C4.25195 16.8619 4.31517 17.0145 4.42769 17.127C4.54021 17.2395 4.69282 17.3027 4.85195 17.3027H16.852C17.0111 17.3027 17.1637 17.2395 17.2762 17.127C17.3887 17.0145 17.452 16.8619 17.452 16.7027V11.4227C15.982 12.5327 13.852 13.2827 11.452 13.4027ZM16.852 7.70273H13.552V5.90273C13.552 5.7436 13.4887 5.59099 13.3762 5.47847C13.2637 5.36595 13.1111 5.30273 12.952 5.30273H8.75195C8.59282 5.30273 8.44021 5.36595 8.32769 5.47847C8.21517 5.59099 8.15195 5.7436 8.15195 5.90273V7.70273H4.85195C4.69282 7.70273 4.54021 7.76595 4.42769 7.87847C4.31517 7.99099 4.25195 8.1436 4.25195 8.30273V9.80273C5.54195 11.2127 8.03195 12.2027 10.852 12.2027C13.672 12.2027 16.162 11.2127 17.452 9.80273V8.30273C17.452 8.1436 17.3887 7.99099 17.2762 7.87847C17.1637 7.76595 17.0111 7.70273 16.852 7.70273ZM12.352 7.70273H9.35195V6.50273H12.352V7.70273Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerLogo);
export default __webpack_public_path__ + "static/media/career-logo.0d70414af78f849b8c9de959c00006c4.svg";
export { ForwardRef as ReactComponent };